import React from 'react'

import { RAIL_LABELS, STEP_LABELS, type View } from '../twinContent'

const STEPS: View[] = ['hall', 'rack', 'tray', 'gpu']

type Props = {
  /** Index into STEPS of the level currently in frame. */
  step: number
  total: number
  levelName: string
  onJump: (view: View) => void
}

export function TwinStepper({ step, total, levelName, onJump }: Props) {
  return (
    <div id="stepper" role="group" aria-label={RAIL_LABELS.stepperGroup}>
      <div id="stepper-track">
        {STEPS.map((view, i) => {
          // Only levels already passed are reachable; disabling the rest also keeps them out of
          // the tab order, so the descent can only be walked forwards.
          const passed = i < step
          return (
            <button
              key={view}
              type="button"
              className={passed ? 'step done' : 'step'}
              data-view={view}
              disabled={i >= step}
              aria-current={i === step ? 'step' : undefined}
              aria-label={STEP_LABELS[view].aria}
              title={STEP_LABELS[view].title}
              onClick={() => onJump(view)}
            />
          )
        })}
      </div>
      <span id="stepper-label">
        <span id="stepper-count">
          {String(step + 1).padStart(2, '0')} / {String(total).padStart(2, '0')}
        </span>
        <span id="stepper-name">{levelName}</span>
      </span>
    </div>
  )
}
